import React from 'react'
import styles from './styles.css'
import Icon from './images/icon.svg'
import Close from './images/close.svg'
import { Grid, GridItem } from '@deal/components'
import UpgradeModal from './UpgradeModal'
import { UserAgentConsumer } from '#src/containers/UserAgent'
import isSupportedBrowser from '#src/services/unsupportedBrowsers'

interface BannerProps {
  text: string
  linkText: string
}

interface BannerState {
  showBanner: boolean
  isModalOpen: boolean
}

class UnsupportedBrowserBanner extends React.Component<BannerProps, BannerState> {
  public constructor(props: BannerProps) {
    super(props)
    this.state = {
      showBanner: true,
      isModalOpen: false
    }
    this.closeBanner = this.closeBanner.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.openModal = this.openModal.bind(this)
  }

  public closeBanner() {
    this.setState({ showBanner: false })
  }

  public closeModal() {
    this.setState({ isModalOpen: false })
  }

  public openModal() {
    this.setState({ isModalOpen: true })
  }

  public render() {
    const { text, linkText } = this.props

    return (
      <UserAgentConsumer>
        {userAgent => {
          return !isSupportedBrowser(userAgent) && this.state.showBanner ? (
            <>
              {this.state.isModalOpen && <UpgradeModal onUpgradeModalClose={this.closeModal} />}
              <div className={styles.outsideContainer}>
                <Grid>
                  <GridItem col={2}>
                    <div className={styles.container}>
                      <div className={styles.icon}>
                        <Icon />
                      </div>
                      <div className={styles.textContainer}>
                        <span>{text}</span>
                        <span onClick={this.openModal} className={styles.linkText}>
                          {linkText}
                        </span>
                        <div />
                      </div>
                      <div className={styles.closeContainer}>
                        <span className={styles.close} onClick={this.closeBanner}>
                          <Close />
                        </span>
                      </div>
                    </div>
                  </GridItem>
                </Grid>
              </div>
            </>
          ) : null
        }}
      </UserAgentConsumer>
    )
  }
}

export default UnsupportedBrowserBanner
